import React from 'react'
import classNames from 'classnames'

import PaginationRender from './PaginationRender/PaginationRender'

import styles from './PaginationList.scss'
import PropTypes from 'prop-types'

export class PaginationList extends React.PureComponent {
    static propTypes = {
        pagesCount: PropTypes.number.isRequired,
        className: PropTypes.string,
        selectedPage: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
    }

    renderButtons = () => {
        const maxIndex = this.props.pagesCount - 1
        const buttons = []
        for (let i = 0; i < this.props.pagesCount; i++) {
            buttons.push(
                <PaginationRender
                    onClick={this.props.onChange}
                    index={i}
                    isLast={i === maxIndex}
                    isSelected={this.props.selectedPage === i}
                    key={i}
                />
            )
        }
        return buttons
    };

    render() {
        const baseClassName = classNames(
            styles.base,
            this.props.className,
        )

        return (
            <div className={baseClassName}>
                {this.renderButtons()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Pagination/PaginationList/PaginationList.jsx